module.exports = __webpack_public_path__ + "media/dashboard/assets/images/credit-card/visa-f054ea3211249480dbb46118cefbd911.svg";